<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><i>Whatsoever you do unto the least of these<br/>my brethren, you do unto me.</i></p>
<p class="ser">—Matthew 25:40</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781617750205_Split6.vue?b113c354